export default {
    contentTitle: {
        guide: '활동안내',
        guideTooltip: '활동은 무엇인가요?',
    },
    modulePageTooltip: {
        tooltip: '함께 진행하면 더 좋아요!',
    },
    questionAccuracy: {
        realtime: '실시간',
        perQuestion: '문항별',
    },
};
